/**
 * Upper bound for every p-calendar in the portal: no date after today can be picked.
 *
 * Bind it as `[maxDate]="maxDate"` with `maxDate: Date = endOfToday();`. p-calendar greys out the
 * later days in its panel and also refuses a later date that is typed or pasted into the input,
 * so the binding covers the free-typing date-of-birth fields as well as the range filters.
 *
 * The bound is the last millisecond of today rather than `new Date()`, so that today stays
 * selectable in full on calendars that also pick a time.
 */
export function endOfToday(now: Date = new Date()): Date {
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
}
